export const EMPLOYEE_CLOCK_TOKEN_KEY = "employee_clock_token";
export const EMPLOYEE_CLOCK_USER_KEY = "employee_clock_user";
export const EMPLOYEE_CLOCK_TENANT_KEY = "employee_clock_tenant";
export const EMPLOYEE_CLOCK_USERNAME_KEY = "employee_clock_username";

export const getEmployeeClockHeaders = () => {
  const token = localStorage.getItem(EMPLOYEE_CLOCK_TOKEN_KEY) || "";
  const tenant = localStorage.getItem(EMPLOYEE_CLOCK_TENANT_KEY) || localStorage.getItem("tenant") || "";
  return {
    "X-Tenant": tenant,
    Authorization: `Bearer ${token}`,
  };
};

export const clearEmployeeClockSession = () => {
  localStorage.removeItem(EMPLOYEE_CLOCK_TOKEN_KEY);
  localStorage.removeItem(EMPLOYEE_CLOCK_USER_KEY);
};
